import React from 'react';
import FormInput from '../../../Components/Ui/FormInput';
import FormSelect from '../../../Components/FormFields/FormSelect';
import Functions from '../../../Helpers/Functions';
import { ENV_VERIFIED_TRAINER, isBrandActive } from '../../../config/environment.config';

interface ReferralFieldsProps {
    option: number | null;
    onOptionChange: (value: number) => void;
    recommandedBy: string;
    onRecommandedByChange: (value: string) => void;
    sponsorship: string;
    onSponsorshipChange: (value: string) => void;
    sponsorshipError?: string;
    /**
     * Côté prof le code devient obligatoire (marque Verified Trainer ou
     * option "Par parrainage") ; côté client tout reste optionnel.
     */
    codeRequired?: boolean;
}

/**
 * Bloc commun prof / client : "Comment avez-vous entendu parler de nous ?",
 * le nom de la personne qui a recommandé et le code de parrainage. Les
 * conditions d'affichage suivent l'option choisie, seul le caractère
 * obligatoire du code varie selon le parent.
 */
const ReferralFields = ({
    option,
    onOptionChange,
    recommandedBy,
    onRecommandedByChange,
    sponsorship,
    onSponsorshipChange,
    sponsorshipError,
    codeRequired = false,
}: ReferralFieldsProps) => {
    const showRecommandedBy = option === 1 || option === 3;
    const showSponsorship = codeRequired || option === 1 || option === 2 || option === 3;

    return (
        <>
            <FormSelect
                defaultValue={option || ''}
                callback={onOptionChange}
                label="Comment avez-vous entendu parler de nous ?"
                data={Functions.recommandedByDatas}
                placeholder="Sélectionner un élément"
                customClass={`bg-white shadow-md shadow-[rgba(0,0,0,25%)] text-[16px] ${isBrandActive(ENV_VERIFIED_TRAINER) ? 'hidden' : ''}`}
            />
            {showRecommandedBy && (
                <FormInput
                    label="Veuillez nous indiquer le nom de la personne concerné (optionnel)"
                    name="recommandedBy"
                    type="text"
                    placeholder="Ex : Thomas E..."
                    value={recommandedBy || ''}
                    onChange={(e) => onRecommandedByChange(e.target.value)}
                />
            )}
            {showSponsorship && (
                <FormInput
                    label={
                        codeRequired
                            ? 'Veuillez entrer le code de parrainage'
                            : 'Avez-vous un code de parrainage ? (optionnel)'
                    }
                    name="sponsorship"
                    type="text"
                    placeholder="Ex : BASA0102"
                    value={sponsorship || ''}
                    error={sponsorshipError}
                    onChange={(e) => onSponsorshipChange(e.target.value)}
                    required={codeRequired}
                />
            )}
        </>
    );
};

export default ReferralFields;
